import script from "./CaseStudies.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseStudies.vue?vue&type=script&setup=true&lang=js"

import "./CaseStudies.vue?vue&type=style&index=0&id=e82b9e38&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e82b9e38"]])

export default __exports__